import React from 'react'
import SectionItem from '../../../components/sectionitem/edit'
import CreateUpdateModal from '../../../components/modals/create-update-modal'

const BrokerEditReferralsAndCommissions = () => {
  const [open, setOpen] = React.useState<boolean>(false)

  return (
    <>
      {open && <CreateUpdateModal type={'Broker'} updated setOpen={setOpen} />}
      <div>
        <div className="divide divide-y divide-gray-200">
          <SectionItem title={'Total referrals'} value={'34'} />
          <SectionItem title={'Commissions this month'} value={'$546'} />
          <SectionItem title={'Lifetime Commission'} value={'$910'} />
        </div>

        <div className="flex">
          <div className="w-1/4" />
          <div className="space-x-5">
            <button
              onClick={() => setOpen(true)}
              className="rounded-lg bg-riverBlue py-2 px-6 text-white font-light"
            >
              Save Changes
            </button>

            <button className="rounded-lg bg-riverStatsLightBlue py-2 px-12 text-riverBlue font-light">
              Discard
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default BrokerEditReferralsAndCommissions
